import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome/index'
import { faSpinner } from '@fortawesome/free-solid-svg-icons/index'

const LoadingSpinner = (props) => (
    <div>
        <FontAwesomeIcon icon={faSpinner} size="lg" /> { props.text ?  props.text : <span>Loading...</span>}
    </div>
);

export default LoadingSpinner;
